import React from 'react';
import { useTranslation } from 'react-i18next';
import { RiUserAddLine } from 'react-icons/ri';
import { useLocation, useNavigate } from 'react-router-dom';

import { Button } from '../common/Button';

type NewPatientProps = {
  returnTo?: string;
};

export const NewPatient: React.FC<NewPatientProps> = ({ returnTo }) => {
  const { t } = useTranslation('Actions');
  const navigate = useNavigate();
  const location = useLocation();

  const handleOpen = () => {
    const destination =
      returnTo ?? `${location.pathname}${location.search}`;
    navigate('/patients/new', { state: { returnTo: destination } });
  };

  return (
    <Button
      onClick={handleOpen}
      size="sm"
      className="whitespace-nowrap px-2 py-1.5 text-xs sm:px-3 sm:py-2 sm:text-sm"
    >
      <RiUserAddLine className="mr-1 h-3 w-3 sm:h-4 sm:w-4" />
      <span className="hidden sm:inline">{t('newPatient')}</span>
      <span className="sm:hidden">{t('patient')}</span>
    </Button>
  );
};
